import type { CSSProperties } from 'react';

import { cn } from '../utils/cn';

import * as styles from './Navbar.css';
import type { NavbarMenuDropdownColumnElementProps } from './Navbar.type';

export function NavbarMenuDropdownColumn(props: NavbarMenuDropdownColumnElementProps) {
  const { element, className, children } = props;
  const { customAttributes, label } = element.attrs || {};

  return (
    <div
      {...props}
      {...customAttributes}
      className={cn(styles.navbarDropdownColumn, className)}
      style={{} as CSSProperties}
    >
      {label && <div className={styles.navbarDropdownColumnLabel}>{label}</div>}
      {children}
    </div>
  );
}
